import { sqLicenseManagementStore } from '@/core/core.stores';
import { Feature } from '@/licenseManagement/licenseManagement.constants';
import { hasValidFeatureInLicense } from '@/licenseManagement/licenseManagement.utilities';
import { hasEarlyAccessCapability } from '@/services/authorization.service';
import { isEnterpriseInsightsEnabled } from '@/services/systemConfiguration.utilities';

export function isInsightBoardEnabled(): boolean {
  return isEnterpriseInsightsEnabled() && hasEarlyAccessCapability();
}

export function isInsightBoardLicensed(): boolean {
  return hasValidFeatureInLicense(sqLicenseManagementStore.getState().license, Feature.Insight);
}

export function isInsightBoardAvailable(): boolean {
  return isInsightBoardEnabled() && isInsightBoardLicensed();
}
